import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Deptors } from '../../interface/company-client.interface';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DicomFormularioComponent } from '../../modals/dicom-formulario/dicom-formulario.component';

@Component({
  selector: 'app-debtor-information',
  templateUrl: './debtor-information.component.html',
  styleUrls: ['./debtor-information.component.scss'],
})
export class DebtorInformationComponent {
  @Input() recieveFilterName: string;
  @Input() deptors: Deptors[];
  @Output() sendfilterTop: EventEmitter<number> = new EventEmitter();
  @Output() debtorCompanyIdToViewRelationship = new EventEmitter<number>;

  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @ViewChild(CdkContextMenuTrigger) menu!: CdkContextMenuTrigger;
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);

  public dataSource!: MatTableDataSource<Deptors>;
  public displayedColumns: string[] = [
    'name',
    'rut',
    'sellTotalAmount',
    'sellInvoices',
    'transferTotalAmount',
    'transferInvoices',
    'clientApprovingStatus',
    'dueApprovingStatus'
  ];
  top: boolean = false ;

  constructor( private dialog: MatDialog ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['deptors']) {
      const newDeptors = changes['deptors'].currentValue;
      this.applyFilter();

      if (newDeptors && newDeptors.length > 0) {
        this.setDataSource(newDeptors);
      }
    }
  }

  private setDataSource(dataSource: Array<Deptors>) {
    this.dataSource = new MatTableDataSource<Deptors>(dataSource);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  filterTop() {
    this.top = !this.top
    this.sendfilterTop.emit(10);
  }

  applyFilter() {
    const filterValue = this.recieveFilterName;
    if (this.dataSource && filterValue !== undefined) {
      const filter = filterValue;
      this.dataSource.filter = filter;
    }
  }

  abrirModalDicom(rut: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '50vw';
    dialogConfig.height = '450px';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = rut;

    const dialogRef = this.dialog.open(DicomFormularioComponent, dialogConfig);
  }

  viewDebtorRelationship(companyId: number){
    this.debtorCompanyIdToViewRelationship.emit(companyId)
  }

}
